export * from './fade-in.animation';
export * from './slide-in.animation';
export * from './animations';
export * from './router.animations';



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/animations/index.ts